export default __webpack_public_path__ + "static/media/UniversLTStd-Light.a922c86f.otf";